interface IconProps {
  className?: string;
  color?: string;
}

export default function SpeedIcon({
  className = "",
  color = "#009804",
}: IconProps) {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 8.60489C0.367347 2.76443 5.9093 -1.2698 11.542 0.366811C16.7483 1.87965 19.424 7.79346 17.2381 12.8225C17.0658 13.2167 16.5578 14.2482 16.1995 14.4408C15.7914 14.6562 15.2653 14.505 15.0658 14.0786C14.8073 13.5239 15.1882 13.2122 15.4195 12.7629C15.8821 11.8689 16.2132 10.9704 16.3175 9.95269H15.3878C15.1293 9.95269 14.8027 9.56302 14.7528 9.31546C14.6531 8.82035 15.0204 8.28399 15.5283 8.28399H16.3175C16.1542 6.9041 15.6372 5.55171 14.7528 4.48356C14.7075 4.48356 14.2177 5.0566 14.0998 5.13912C13.7007 5.41418 13.1066 5.27207 12.9025 4.82738C12.5669 4.11223 13.22 3.74548 13.61 3.27787C12.5079 2.47561 11.229 1.84297 9.84581 1.7467V2.68649C9.84581 2.80569 9.61451 3.0945 9.5102 3.16785C9.19274 3.39707 8.70748 3.36039 8.43991 3.06699C8.39002 3.01198 8.23129 2.74609 8.23129 2.68649V1.71003C6.81633 1.85672 5.53288 2.43435 4.39909 3.27329C4.79365 3.74089 5.44218 4.10764 5.10658 4.8228C4.89796 5.26748 4.30385 5.4096 3.9093 5.13454C3.79138 5.05202 3.30159 4.47897 3.25624 4.47897C2.37188 5.54713 1.85941 6.89951 1.69161 8.2794H2.48073C2.98866 8.2794 3.35601 8.82035 3.25624 9.31088C3.20635 9.55844 2.87982 9.94811 2.62132 9.94811H1.69161C1.79138 10.9658 2.12698 11.8598 2.58957 12.7583C2.82086 13.203 3.20181 13.5193 2.94331 14.074C2.85261 14.262 2.60317 14.4774 2.39909 14.5187C1.70522 14.6608 1.41043 14.0419 1.12472 13.5285C0.539683 12.4649 0.0861678 10.9888 0.00453515 9.7739V8.60031L0 8.60489Z"
        fill={color}
      />
      <path
        d="M5.19723 13.3403H12.78C13.7641 13.4733 13.7505 14.899 12.7483 14.9999H5.22445C4.26753 14.8532 4.24485 13.5145 5.1927 13.3403H5.19723Z"
        fill={color}
      />
      <path
        d="M11.8777 5.59275C12.6487 5.48731 13.1113 6.41335 12.5897 6.98639L10.2496 9.35192C10.5671 10.8373 8.83918 11.9375 7.68725 10.9152C6.75301 10.09 7.12942 8.49465 8.33577 8.19666C8.61242 8.1279 8.83918 8.1554 9.11128 8.15999L11.465 5.77613C11.5784 5.68902 11.7371 5.61109 11.8777 5.59275Z"
        fill={color}
      />
    </svg>
  );
}
